var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalInterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8071,
    y: 10.2329,
    width: 8,
    height: 2,
    rx: 1,
    transform: "rotate(90 13.8071 10.2329)",
    fill: "#78D2F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8071,
    y: 15.2329,
    width: 8,
    height: 2,
    rx: 1,
    transform: "rotate(-180 16.8071 15.2329)",
    fill: "#78D2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37458 0.638616C8.7046 -0.212873 9.9094 -0.212871 10.2394 0.638618L11.9806 5.13102C12.1224 5.4971 12.4654 5.74628 12.8574 5.7681L17.668 6.0358C18.5798 6.08654 18.9521 7.23237 18.2443 7.80936L14.7283 10.6754C14.4869 9.8421 13.7181 9.23286 12.807 9.23286C11.7024 9.23286 10.807 10.1283 10.807 11.2329V12.2329H9.807C8.70243 12.2329 7.807 13.1283 7.807 14.2329C7.807 14.6693 7.94681 15.0731 8.18408 15.4019L4.71588 17.6383C3.94839 18.1332 2.97369 17.425 3.20719 16.5422L4.43914 11.8843C4.53953 11.5048 4.40853 11.1016 4.10421 10.8535L0.369727 7.80936C-0.338107 7.23237 0.0341986 6.08654 0.945994 6.0358L5.75657 5.7681C6.14857 5.74628 6.49154 5.4971 6.63343 5.13102L8.37458 0.638616ZM14.807 16.2329H15.325L15.325 16.2329H14.8071C14.8071 16.2329 14.807 16.2329 14.807 16.2329V16.2329Z",
    fill: "#78D2F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalInterest);
export default __webpack_public_path__ + "static/media/anal-interest.ff78314e77419a6bf334ae387d260363.svg";
export { ForwardRef as ReactComponent };